<template>
  <section class="agb">
    <div class="container">
      <h1>{{ $t('agb.title') }}</h1>

      <p>{{ $t('agb.paragraph1') }}</p>
      <p>{{ $t('agb.paragraph2') }}</p>
      <p>{{ $t('agb.paragraph3') }}</p>
      <p>{{ $t('agb.paragraph4') }}</p>
      <p>{{ $t('agb.paragraph5') }}</p>
      <p>{{ $t('agb.paragraph6') }}</p>
      <p>{{ $t('agb.paragraph7') }}</p>
      <p>{{ $t('agb.paragraph8') }}</p>
      <p>{{ $t('agb.paragraph9') }}</p>
      <p>{{ $t('agb.paragraph10') }}</p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
};
</script>

<style scoped>
.agb {
  padding-top: 50px;
  padding-bottom: 50px;
  background-color: #abb8c324;
  --fontFamily: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
}

.agb h1 {
  font-size: 30px;
  padding-bottom: 50px;
}

.agb p {
  color: #3a4f66;
  font-size: 16px;
  line-height: 25px;
  letter-spacing: .5px;
  padding-top: 10px;
  padding-bottom: 10px;
}

@media only screen and (max-width: 1025px) {
  .agb p {
    font-size: 20px;
  }
}
</style>